import { render, staticRenderFns } from "./DropboxOAuth.vue?vue&type=template&id=783c1be4&"
import script from "./DropboxOAuth.vue?vue&type=script&lang=js&"
export * from "./DropboxOAuth.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports